import videoExtensions from '../../views/Upload/VideoUpload/helpers';
import { photoUploadFilter } from '../../../../util/photo-upload';

export const isPhoto = file => photoUploadFilter(file);
export const isVideo = file => {
  const extension = file.name.split('.').slice(-1)[0].toLowerCase();

  return (
    videoExtensions.includes(extension) ||
    videoExtensions.includes((file.type ?? '').replace('video/', '')) ||
    file?.name?.toLowerCase().includes('.hevc')
  );
};
